// Table/form styles shared by the Fees panels. Mirrors the invoice-config
// shared.ts on dev; local copy because that module is not on prod yet.
export const headerClass =
  'border-b border-gray-200 pb-2 pr-3 text-start text-xs font-bold uppercase text-gray-600 dark:border-white/20 dark:text-white';
export const cellClass = 'py-2 pr-3 text-sm text-navy-700 dark:text-white';
export const inputCls =
  'w-full rounded-md border border-gray-200 bg-white px-3 py-2 text-sm dark:bg-navy-800 dark:text-white';
export const primaryBtn =
  'rounded bg-brand-500 px-3 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50';
export const secondaryBtn =
  'rounded border border-gray-200 px-3 py-2 text-sm dark:text-white disabled:opacity-50';
export const smallBtn =
  'rounded border border-gray-200 px-2 py-1 text-xs dark:text-white disabled:opacity-50';
